import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import "./AppHome.css";

export default function PaymentWarningPage() {
  const { state } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="welcome-container2">
      <div className="welcome-Regi-card">
        <h1>⚠️ Payment Reminder</h1>
        <p>Your next payment date is:</p>
        <h3>{new Date(state?.nextDueDate).toDateString()}</h3>
        <p>Please renew your membership soon.</p>

        <div className="icon-circle">✓</div>

                <h1>Your attendance has been marked successfully!</h1>
                <p>Thank you for your cooperation.</p>


      </div>
    </div>
  );
}
